import _ from 'lodash';
import { FETCH_CATEGORIES_SUCCESS } from '../actions/fetch-categories';
import { CREATE_CATEGORY_SUCCESS } from '../actions/create-category';
import { DELETE_CATEGORY_SUCCESS } from '../actions/delete-category';
import { UPDATE_CATEGORY_SUCCESS } from '../actions/update-category';
import { CHANGE_CATEGORY_RANK } from '../actions/change-category-rank';
import { SET_CATEGORIES } from '../actions/set-categories';
import { UPDATE_CATEGORY_COUNTERS } from '../actions/category-socket';
import { SUBSCRIBE_REQUEST, SUBSCRIBE_FAILURE } from '../actions/subscribe';
import { UNSUBSCRIBE_REQUEST, UNSUBSCRIBE_FAILURE } from '../actions/unsubscribe';

const initialState = [];
const SORT_BY = 'rank';

export default (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case FETCH_CATEGORIES_SUCCESS:
      return _.sortBy(payload, SORT_BY);
    case CREATE_CATEGORY_SUCCESS:
      return _.sortBy([...state, payload], SORT_BY);
    case UPDATE_CATEGORY_COUNTERS:
    case UPDATE_CATEGORY_SUCCESS: {
      const categoryIndex = _.findIndex(state, category => category._id === payload._id);
      const category = state[categoryIndex];
      return _.sortBy(
        [
          ...state.slice(0, categoryIndex),
          {
            ...category,
            ...payload,
          },
          ...state.slice(categoryIndex + 1, state.length),
        ],
        SORT_BY
      );
    }
    case CHANGE_CATEGORY_RANK: {
      const { rank, categoryId } = payload;
      const category = _.find(state, category => category._id === categoryId);
      const tempState = _.filter(state, category => category._id !== categoryId);

      tempState.splice(rank, 0, category);
      return _(tempState)
        .map((category, rank) => ({
          ...category,
          rank,
        }))
        .sortBy(SORT_BY)
        .value();
    }
    case DELETE_CATEGORY_SUCCESS:
      return state.filter(category => category._id !== payload);
    case SET_CATEGORIES:
      return [...payload];
    case SUBSCRIBE_REQUEST:
      return setIsSubscribed(state, payload, true);

    case SUBSCRIBE_FAILURE:
      return setIsSubscribed(state, payload, false);

    case UNSUBSCRIBE_REQUEST:
      return setIsSubscribed(state, payload, false);

    case UNSUBSCRIBE_FAILURE:
      return setIsSubscribed(state, payload, true);

    default:
      return state;
  }
};

function setIsSubscribed(state, { type, _id }, isSubscribed) {
  if (type !== 'category') {
    return state;
  }

  const index = _.findIndex(state, category => category._id === _id);
  return [
    ...state.slice(0, index),
    {
      ...state[index],
      isSubscribed,
    },
    ...state.slice(index + 1),
  ];
}



// WEBPACK FOOTER //
// ./app/reducers/categories.js